import {
  ComponentFactoryResolver,
  ComponentRef,
  Directive,
  EventEmitter,
  HostListener,
  Input,
  OnDestroy,
  OnInit,
  Output,
  ViewContainerRef,
} from '@angular/core';
import { FormControl, FormGroup } from '@angular/forms';
import { FieldConfig } from '../field.interface';

import { C4dWebInputComponent } from '../c4dweb-input/c4dweb-input.component';
import { C4dWebTextAreaComponent } from '../c4dweb-textarea/c4dweb-textarea.component';
import { C4dWebCheckboxComponent } from '../c4dweb-checkbox/c4dweb-checkbox.component';
import { C4dWebRadiobuttonComponent } from '../c4dweb-radiobutton/c4dweb-radiobutton.component';
import { C4dWebSelectComponent } from '../c4dweb-select/c4dweb-select.component';
import { C4dWebButtonComponent } from '../c4dweb-button/c4dweb-button.component';
import { C4dWebDateComponent } from '../c4dweb-date/c4dweb-date.component';
import { Subscription } from 'rxjs/internal/Subscription';


const componentMapper = {
  input: C4dWebInputComponent,
  button: C4dWebButtonComponent,
  select: C4dWebSelectComponent,
  date: C4dWebDateComponent,
  radiobutton: C4dWebRadiobuttonComponent,
  checkbox: C4dWebCheckboxComponent,
  textarea: C4dWebTextAreaComponent,
};
@Directive({
  selector: '[c4dwebDynamicField]',
})
export class DynamicFieldDirective implements OnInit, OnDestroy {
  @Input() field: FieldConfig;
  @Input() group: FormGroup;

  @Output() evenChange: EventEmitter<any> = new EventEmitter<any>();

  componentRef: any;

  sub: Subscription;

  constructor(
    private resolver: ComponentFactoryResolver,
    private container: ViewContainerRef
  ) {}

  ngOnInit(): void {
    const factory = this.resolver.resolveComponentFactory(
      componentMapper[this.field.type]
    );
    this.componentRef = this.container.createComponent(factory);
    this.componentRef.instance.field = this.field;

    if (this.group) {
      this.componentRef.instance.group = this.group;
    }
    this.sub = this.componentRef.instance.eventChange?.subscribe((data) => {
      console.log('directive', data);
      this.evenChange.emit(data);
    });
  }

  ngOnDestroy(): void {
    if (this.sub) {
      this.sub.unsubscribe();
    }
  }
}
